module.exports = __webpack_public_path__ + "static/media/ajax-loader.82e1b5fc.gif";